import { IntervalSchema, RuleEditorSchema } from "@superwall-me/schema";
export const parseTriggerExperiment = (triggerExperiment)=>{
    const interval = triggerExperiment.interval ? IntervalSchema.parse(triggerExperiment.interval) : null;
    const ruleConditions = triggerExperiment.ruleConditions ? RuleEditorSchema.parse(triggerExperiment.ruleConditions) : null;
    return {
        ...triggerExperiment,
        interval,
        ruleConditions
    };
};
